import { render } from "./CaseStatisticsTable.vue?vue&type=template&id=1a84fb9b&ts=true"
import script from "./CaseStatisticsTable.vue?vue&type=script&lang=ts"
export * from "./CaseStatisticsTable.vue?vue&type=script&lang=ts"

import "./CaseStatisticsTable.vue?vue&type=style&index=0&id=1a84fb9b&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__